import { isRenameFromValue, RENAME_SEEN_KEY } from '~/constants/rename-notice'

function queryHasRenameFlag(from: unknown) {
  if (isRenameFromValue(from)) return true
  return Array.isArray(from) && from.some(isRenameFromValue)
}

export function useRenameNotice() {
  const showRenameNotice = useState('rename-notice', () => false)

  const readSeen = () => {
    if (!import.meta.client) return false

    try {
      return localStorage.getItem(RENAME_SEEN_KEY) === '1'
    } catch {
      return false
    }
  }

  const stripFromParam = async () => {
    const route = useRoute()
    if (!queryHasRenameFlag(route.query.from)) return

    const query = { ...route.query }
    delete query.from
    await navigateTo({ path: route.path, query, hash: route.hash }, { replace: true })
  }

  const syncRenameNotice = async () => {
    if (!import.meta.client) return

    const route = useRoute()
    const pending = queryHasRenameFlag(route.query.from) && !readSeen()
    showRenameNotice.value = pending
    document.documentElement.classList.toggle('rename-pending', pending)

    if (queryHasRenameFlag(route.query.from) && !pending) {
      await stripFromParam()
    }
  }

  const dismissRenameNotice = async () => {
    try {
      localStorage.setItem(RENAME_SEEN_KEY, '1')
    } catch {}

    showRenameNotice.value = false
    document.documentElement.classList.remove('rename-pending')
    await stripFromParam()
  }

  return { showRenameNotice, syncRenameNotice, dismissRenameNotice }
}
